import { atlasDay, atlasIsStale, atlasReading, type AtlasLocation, type AtlasMode, type AtlasSport, type AtlasWeather } from "./atlas";

export type AtlasSky = "sun" | "partly-cloudy" | "cloud" | "rain" | "snow" | "storm" | "fog" | "mixed" | "unavailable";
export const ATLAS_SKY_LABELS: Record<AtlasSky, string> = {
  sun: "Clear skies", "partly-cloudy": "Partly cloudy", cloud: "Overcast", rain: "Rain or showers",
  snow: "Snowfall", storm: "Thunderstorms", fog: "Fog", mixed: "Local skies vary", unavailable: "Sky forecast unavailable",
};

/** Daily forecast symbols, never inferred from the sport or geographical season. */
export function atlasSky(weather: AtlasWeather): AtlasSky {
  const code = weather[0];
  if (code !== null && code >= 95) return "storm";
  if ((weather[1] ?? 0) > 0.2 || [71, 73, 75, 77, 85, 86].includes(code ?? -1)) return "snow";
  if (code === null) return "unavailable";
  if (code <= 1) return "sun";
  if (code === 2) return "partly-cloudy";
  if (code === 3) return "cloud";
  if (code === 45 || code === 48) return "fog";
  if (code >= 51 && code <= 82) return "rain";
  return "unavailable";
}

/** A small illustration is not a participant count, tracked route or opening claim. */
export function atlasIllustratedSport(location: AtlasLocation, date: string, mode: AtlasMode, now = Date.now()): AtlasSport | null {
  const day = atlasDay(location, date);
  if (!day || atlasIsStale(location, now) || atlasSky(day.w) === "storm") return null;
  const reading = atlasReading(day, mode);
  return reading && reading[1] >= 5 && reading[2] !== "inferred" && reading[3] === "clear" ? reading[0] : null;
}

/** Stable for the selected day, so panning does not move the discovery. */
export function atlasDiscoverySeed(value: string): number {
  let hash = 2166136261;
  for (const char of value) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
  return hash >>> 0;
}
